module.exports = __webpack_public_path__ + "static/llama-bg-02-9e46112d52c86a4ae37e03a765ded70a.png";